import { Extension } from '@tiptap/core';
import { EXTENSION_TYPE_NAME } from './constants';
export const DaMuro = Extension.create({
    name: EXTENSION_TYPE_NAME,
    addCommands () {
        return {
            daMuroUseDrawing: (deviation)=>({ editor, chain, dispatch, tr, commands, state })=>{
                    if (dispatch) {
                        return chain().daDeviationAddDeviation(deviation).run();
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=muro.js.map